import { Link } from "react-router-dom"
import { Dropdown } from "react-bootstrap"
import { useToggle } from "hooks"
import { useAuth0 } from "@auth0/auth0-react"
import { getHostInfo } from "utils/networking"

type ProfileDropdownProps = {
  username: string
  userTitle?: string
}

const ProfileDropdown = ({ userTitle, username }: ProfileDropdownProps) => {
  const [isOpen, toggleDropdown] = useToggle()
  const { logout } = useAuth0()
  const { logoutUrl } = getHostInfo()

  return (
    <Dropdown show={isOpen} onToggle={toggleDropdown}>
      <Dropdown.Toggle
        variant="link"
        id="dropdown-profile"
        as={Link}
        to="#"
        onClick={(e) => {
          e.preventDefault()
          toggleDropdown()
        }}
        className="dropdown-toggle nav-user arrow-none flex items-center px-2 !shadow-none"
      >
        <span className="flex items-center justify-start gap-1 h-full text-gray-600">
          <span className="flex items-center justify-center rounded-full w-6 h-6 border-[1px] border-slate-400 text-gray-400">
            <i className="ri-user-fill"></i>
          </span>
          <span className="account-user-name font-25 text-gray-600">
            {username}
          </span>
          <span className="account-position text-gray-600">{userTitle}</span>
        </span>
      </Dropdown.Toggle>
      <Dropdown.Menu
        align={"end"}
        className="dropdown-menu-animated topbar-dropdown-menu profile-dropdown"
      >
        <div onClick={toggleDropdown}>
          <div className="dropdown-header noti-title">
            <h6 className="text-overflow m-0">Welcome!</h6>
          </div>
          <Link to="/profile" className="dropdown-item notify-item">
            <i className="ri-user-fill me-1"></i>
            <span>My Account</span>
          </Link>
          <Link
            to="/"
            className="dropdown-item notify-item"
            onClick={async (e) => {
              e.preventDefault()
              await logout({
                logoutParams: {
                  returnTo: logoutUrl,
                },
              })
            }}
          >
            <i className="ri-logout-box-r-line me-1"></i>
            <span>Logout</span>
          </Link>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  )
}

export default ProfileDropdown
